import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { CompanyManagementContentService } from '../../services/company-management-content.service';
import { MenuNavExpandedComponent } from '../menu-nav-expanded/menu-nav-expanded.component';
import { NgIf } from '@angular/common';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-company-management',
    templateUrl: './company-management.component.html',
    styleUrls: ['./company-management.component.scss'],
    imports: [MenuNavExpandedComponent, NgIf, RouterOutlet]
})
export class CompanyManagementComponent implements OnInit, OnDestroy {
  renderer: boolean = true;
  content:any;
  private destroy$ = new Subject<void>();
  constructor(private _CommonService: CommonService, private _CompanyManagementService:CompanyManagementService,private companyManageContentService:CompanyManagementContentService) {
    this._CommonService.componentRendererTrigger.subscribe(($:boolean) => {
      this.renderer = $;
    })
  }

  ngOnInit(): void {
    this.companyManageContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.content = res;
    })
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this._CompanyManagementService.page_landing('Company Management', 'NA', 'Company Management Workflow')//GTM use
  }
  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }
}
